module.exports = __webpack_public_path__ + "static/media/fill_outline_pattern.fragment.4c317cf2.glsl";